import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {
  Badge, Nav, NavItem, Button
} from 'reactstrap';
import classNames from 'classnames';
import nav from './_nav';

import Helpers from "../../Utils/Helpers";
import Registry from "../../Utils/Registry";
import ConfigurationModal from '../ConfigurationModal';


class Sidebar extends Component {
  constructor(props){
    super(props);

    this.api = Registry.registered("api");
    this.state = {
        logo: null,
        user: null,
        business_list: [],
        business: null,
        confirmationOpen: false
    };

    this.loadUserBusinesses = this.loadUserBusinesses.bind(this);
    this.changeUserBusiness = this.changeUserBusiness.bind(this);
    this.toggleConfirmation = this.toggleConfirmation.bind(this);
  }

  componentDidMount(){
      let user = Registry.observe(this, "user", user => {
        this.loadUserBusinesses(user);
      });
      if(user)
        this.loadUserBusinesses(user);
      let logo = Registry.observe(this, "business-logo", logo => {
          this.setState({logo:logo});
      });
  }

  loadUserBusinesses(user=null){
    if(!user)
      user = this.state.user;
    if(user){
      this.setState({
          business_list: []
      });
      this.api.get("/customers/business")
        .then(results => {
          results.business.sort((a, b) => {
            if(a.name > b.name) return 1;
            if(a.name < b.name) return -1;
            return 0;
          });
          this.setState({
            user: user,
            business_list: results.business
          });
        });
    }
      this.loadCurrentBusiness(user);
  }

  loadCurrentBusiness = (user) => {
      this.api.get("/business/" + user.business_id)
          .then(res => {
              this.setState({
                  business: res.business,
				          confirmationOpen: res.business.account_setup === 0
              });
          });
  };

  changeUserBusiness(e){
    if(this.state.user){
      this.props.toggleLoadingHandler();
      this.api.put("/customers/" + this.state.user.id, {
        business_id: e.target.value
      })
        .then(results => {
          window.location.reload();
        })
        .catch(error => {
          // TODO : Notification Erreur
        });
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';

  }

  toggleConfirmation(){
      this.setState({confirmationOpen: !this.state.confirmationOpen});
  }

  toggleByAccountSetup = () => {
      if (this.state.business.account_setup === 0 || this.state.business.account_setup === 2)
          this.toggleConfirmation();
      else
          Helpers.goTo("/commander");
  };

  contentModal = () => {
      if (this.state.business !== null) {
          if (this.state.business.account_setup === 0) {
              return <div>
                  Avant de pouvoir commander, nous avons besoin de connaitre quelques informations. L'activation de votre compte se fera
                  <span className="bold"> sous quelques heures.</span>
              </div>
          } else if (this.state.business.account_setup === 2) {
              return <div>Votre demande est en cours de traitement</div>
          }
      }
  };

  render() {
    const props = this.props;
    const activeRoute = this.activeRoute;
    const handleClick = this.handleClick;

    // badge addon to NavItem
    const badge = (badge) => {
      if (badge) {
        const classes = classNames( badge.class );
        return (<Badge className={ classes } color={ badge.variant }>{ badge.text }</Badge>)
      }
    };

    // simple wrapper for nav-title item
    const wrapper = item => { return (!item.wrapper ? item.name : (React.createElement(item.wrapper.element, item.wrapper.attributes, item.name))) };

    // nav list section title
    const title =  (title, key) => {
      const classes = classNames( "nav-title", title.class);
      return (<li key={key} className={ classes }>{wrapper(title)} </li>);
    };

    // nav list divider
    const divider = (divider, key) => (<li key={key} className="divider" />);

    // nav item with nav link
    const navItem = (item, key) => {
      const classes = classNames( "nav-link", item.class);
      return (
        <NavItem key={key}>
          <NavLink to={item.url} className={ classes } activeClassName="active" onClick={this.props.onItemClicked}>
            <i className={item.icon} />{item.name}{badge(item.badge)}
          </NavLink>
        </NavItem>
      )
    };

    // nav dropdown
    const navDropdown = (item, key) => {
      return (
        <li key={key} className={activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick.bind(this)}><i className={item.icon} /> {item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children)}
          </ul>
        </li>)
    };

    // nav link
    const navLink = (item, idx) =>
      item.title ? title(item, idx) :
      item.divider ? divider(item, idx) :
      item.children ? navDropdown(item, idx)
                    : navItem(item, idx) ;

    // nav list
    const navList = (items) => {
      return items.map( (item, index) => navLink(item, index) );
    };

    // sidebar-nav root
    return (
      <div className="sidebar d-flex flex-column justify-content-between">
        <nav className="sidebar-nav">
          <div className="display-logo">
            <div className="bg-white logo" style={{height: "70px"}}>
                {
                    this.state.logo ?
                        <img src={this.state.logo} style={{height:"55px", margin: "auto"}} />
                        :
                        this.state.user ?
                            this.state.user.business_name
                            :
                            ""
                }
            </div>
          </div>

          <Nav>
            {navList(nav.items)}
          </Nav>

          <div className="ty-sidebar-spacer">

            {
              this.state.user && this.state.business_list.length > 1 ?
                <select value={this.state.user.business_id} className="form-control marg-b-30" onChange={this.changeUserBusiness}>
                    {
                      this.state.business_list.map(b => {
                        return <option key={b.id} value={b.id}>{ b.name }</option>;
                      })
                    }
                </select>
                :
                null
            }

            <div className="border-t-1-gray_dark pad-t-30">
                <Button color="primary" className="wp-100" onClick={ this.toggleByAccountSetup }>
                    Commander
                </Button>
              </div>
          </div>
        </nav>

          <ConfigurationModal
              isOpen={this.state.confirmationOpen}
              toggle={this.toggleConfirmation}
              user={this.state.user}
              business={this.state.business}
              title="Configuration de votre compte"
              content={this.contentModal()}
              loadCurrentBusiness={this.loadUserBusinesses}
          />

        <div className="">
          v{ APP_VERSION }
        </div>
      </div>
    )
  }
}

Sidebar.defaultProps = {
    toggleLoadingHandler: () => {},
    onItemClicked: () => {}
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js